import React from 'react';
import { useHitsPerPage } from 'react-instantsearch';
import { pushToDataLayer } from '@jbhi-fi/utils/src/ga4Tracking/datalayer';

type CustomHitsPerPageProps = {
  searchTerm: string| undefined;
};

const HitsPerPage: React.FC<CustomHitsPerPageProps> = ({ searchTerm }) => {
  const { refine, items } = useHitsPerPage({
    items: [
      { value: 36, label: '36', default: true },
      { value: 72, label: '72' },
      { value: 100, label: '100' },
    ],
  });
  const trackHitsPerPageClick = (value: string) => {
    window.dataLayer.push({
      event: 'custom.hitsPerPage.set',
      value,
    });
    pushToDataLayer({
      event: 'select_page_size',
      search_type: 'site search',
      filter_name: 'show',
      filter_value: value,
      search_term: searchTerm,
    });
  };

  return (
    <div className="page-size-container">
      <ul className="page-size-list">
        <li>
          <span>Show:</span>&nbsp;&nbsp;
        </li>
        {items.map(item => (
          <li key={item.value}>
            <a
              href="#"
              style={{ fontWeight: item.isRefined ? 'bold' : '' }}
              onClick={e => {
                e.preventDefault();
                refine(Number(item.value));
                trackHitsPerPageClick(item.value.toString());
              }}
            >
              {item.label}
            </a>
            &nbsp;&nbsp;
          </li>
        ))}
      </ul>
    </div>
  );
};

const CustomHitsPerPage = HitsPerPage;

export default CustomHitsPerPage;
